
const TypingDots: React.FC = () => {
  return (
      <div className="dot-container">
        <div style={{ backgroundColor: "white" }} className="dot"></div>
        <div style={{ backgroundColor: "white" }} className="dot"></div>
        <div style={{ backgroundColor: "white" }} className="dot"></div>
      </div>
  );
};

export default TypingDots;
